import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Tagbar/Tag/Tag.css';

export const prototypeName = '4DR0JnaGyrcxGMjoZgA5s9gzzkNy1KINXDLDNQkMujKM7VpVg8h3xzx5oZlxTaRGVj4ngpixkb68N';
export {styles};